import React from 'react'

import {useTransition} from '../../usetransition'
import {MapFeature} from '../components'
import {LOAD_ROUTE_KEY} from './consts'
import {OnBoundsChangeType, Point, RouteType, DrawingStyle} from './types'
import {isRoutePoints, jamsToStyle, loadRoute} from './utils'

const DEFAULT_STYLE: DrawingStyle = {
  stroke: [{color: 'rgb(52, 52, 52)', opacity: 0.6, width: 4}],
}

type Props = {
  /**
   * Отрисовывать ли пробки
   * @default true
   */
  drawJams?: boolean
  onBoundsChange?: OnBoundsChangeType
  /**
   * Точки маршрута. Их должно быть как минимум две
   */
  points: Point[]
  style?: DrawingStyle
}

export function Route({drawJams = true, onBoundsChange, points, style = DEFAULT_STYLE}: Props) {
  const [state, startTransition] = useTransition<RouteType | null>(() => loadRoute(points, {onBoundsChange}), {
    key: LOAD_ROUTE_KEY,
  })
  const route = state.payload
  const isRouteAvailable = isRoutePoints(points)
  React.useEffect(() => {
    startTransition(() => loadRoute(points, {onBoundsChange}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [points])

  if (!route || !isRouteAvailable) {
    return null
  }

  return <MapFeature {...route} style={drawJams ? jamsToStyle(route.properties.jams) : style} />
}
